import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {jobProfilesView_template} from "../components/templates/jobProfilesView_template";
import {header} from "./header";


declare var ko: any;
declare var page: any;

export class job_profiles_view extends vnModule_knockoutJS{

    protected jobProfile: jobProfilesView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    protected getModuleName(): string{

        return "job_profiles_view";
    }

    buildContent(): Array<Element>{

        this.jobProfile = new jobProfilesView_template("view_template", this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Job Profile");

        return [this.jobProfile.build()];
    }

    public fillPage(): void{

        this.getData();
    }

    protected getData(){

        // LOADING : starts
        this.loadingIn(this.jobProfile.builtTemplate);

        let usrReq_url: string = '/api/job/profiles/get/'+ this.getVnAppZone().app.params.id;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.jobProfile.getViewModelForRequest())]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.setUpForm(responseParsed.data.jobProfile);
                obj.jobProfile.setConfigOptions(responseParsed.data.configOptions);
            });

            obj.loadingOut(obj.jobProfile.builtTemplate);
        }
    }

    public setUpForm(data): void{

        this.jobProfile.setId(data.id);
        this.jobProfile.setName(data.name);
        this.jobProfile.setBrand(data.brand.name);
        this.jobProfile.setLocation(data.location);
        this.jobProfile.setAvailability(data.availability);
        this.jobProfile.setExperience(data.experience);
        this.jobProfile.setLongDescription(data.longDescription);
        this.jobProfile.setAdditionalText(data.additionalText);
        this.jobProfile.setRole(data.role);
        this.jobProfile.setNetworkCategory(data.networkCategory);
        this.jobProfile.setGeos(data.geos);
        this.jobProfile.setResume(data.resume ? data.resume.name : '');
        this.jobProfile.setCoverLetter(data.coverLetter ? data.coverLetter.name :  '');
        this.jobProfile.setReferentialWork(data.referentialWork ? data.referentialWork.name : '');
        this.jobProfile.setReferentialWorkInstructions(data.referentialWorkInstructions);
        this.jobProfile.setWrittenSample(data.writtenSample ? data.writtenSample.name : '');
        this.jobProfile.setWrittenSampleInstructions(data.writtenSampleInstructions);
        this.jobProfile.setImageSample(data.imageSample ? data.imageSample.name : '');
        this.jobProfile.setImageSampleInstructions(data.imageSampleInstructions);
        this.jobProfile.setQuestions(data.questions);
        this.jobProfile.setPosition(data.position);
        this.jobProfile.setImageUrl(data.imageUrl);
        this.jobProfile.setIsActive(data.isActive ? 'Enabled' : 'Disabled');
        this.jobProfile.setLastDateEnabled(data.lastDateEnabled);
        this.jobProfile.setLastDateDisabled(data.lastDateDisabled);
        this.jobProfile.setDateCreated(data.dateCreated);
        this.jobProfile.setIsEditShown(true);
    }

    protected edit(id){

        page('/job/profiles/edit/'+ id)
    }

    protected goBack(){

        let previousUrl = this.loadPreviousPage(window.location.href);
        if(previousUrl){
            page.redirect(previousUrl);
        }else{
            page.redirect('/job/profiles');
        }
    }

}


// WEBPACK FOOTER //
// ./js/modules/job_profiles_view.ts